import React from 'react';

import { Button, ButtonProps } from '@mui/material';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';

export type LinkButtonProps = ButtonProps &
  Pick<RouterLinkProps, 'to' | 'replace'>;

export const LinkButton: React.FC<LinkButtonProps> = (props) => {
  // @ts-expect-error - Not 100% sure how to make TS happy but this does work
  return <Button {...props} component={RouterLink} />;
};
